import { __assign } from "tslib";
import React from "react";
import { makeStyles, Tooltip as MuiTooltip } from "@material-ui/core";
var useStyles = makeStyles(function () {
  return {
    span: {
      display: "inline-block",
      verticalAlign: "top"
    }
  };
});

var Tooltip = function Tooltip(props) {
  var classes = useStyles();
  return React.createElement(MuiTooltip, __assign({}, props), React.createElement("span", {
    className: classes.span
  }, props.children));
};

export default Tooltip;